var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`page-${_vm.languageCode}`,attrs:{"id":"main"}},[(_vm.routerAlive)?_c('router-view'):_vm._e(),_c('RectLoading',{directives:[{name:"show",rawName:"v-show",value:(Boolean(_vm.showLoading)),expression:"Boolean(showLoading)"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }